import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgWaitTime = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12 7.5V12"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.9 14.25L12 12"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.2687 9.34688H21.0187V5.59688"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.8314 17.8313C16.6779 18.9857 15.2079 19.7721 13.6073 20.091C12.0068 20.4099 10.3477 20.2469 8.83978 19.6227C7.3319 18.9984 6.04302 17.941 5.1362 16.5842C4.22938 15.2273 3.74536 13.632 3.74536 12C3.74536 10.368 4.22938 8.7727 5.1362 7.41585C6.04302 6.059 7.3319 5.00158 8.83978 4.37735C10.3477 3.75313 12.0068 3.59014 13.6073 3.90902C15.2079 4.22789 16.6779 5.0143 17.8314 6.16875L21.0189 9.34688"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgWaitTime.displayName = 'SvgWaitTime';
export default SvgWaitTime;
